export default {"src":"/_next/static/media/abc-logo.681cd188.svg","height":36,"width":35};